(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('measurement-unit', {
            parent: 'entity',
            url: '/measurement-unit?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.measurementUnit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/measurement-unit/measurement-units.html',
                    controller: 'MeasurementUnitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('measurementUnit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('measurement-unit-detail', {
            parent: 'entity',
            url: '/measurement-unit/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.measurementUnit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-detail.html',
                    controller: 'MeasurementUnitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('measurementUnit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MeasurementUnit', function($stateParams, MeasurementUnit) {
                    return MeasurementUnit.get({id : $stateParams.id});
                }]
            }
        })
        .state('measurement-unit.new', {
            parent: 'measurement-unit',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-dialog.html',
                    controller: 'MeasurementUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('measurement-unit', null, { reload: true });
                }, function() {
                    $state.go('measurement-unit');
                });
            }]
        })
        .state('measurement-unit.edit', {
            parent: 'measurement-unit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-dialog.html',
                    controller: 'MeasurementUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MeasurementUnit', function(MeasurementUnit) {
                            return MeasurementUnit.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('measurement-unit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('measurement-unit.delete', {
            parent: 'measurement-unit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/measurement-unit/measurement-unit-delete-dialog.html',
                    controller: 'MeasurementUnitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MeasurementUnit', function(MeasurementUnit) {
                            return MeasurementUnit.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('measurement-unit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
